"use client";
import Button from "@/components/common/button";
import Link from "next/link";
import IsaIntro from "./_sections/isa-intro";
import IsaIns from "./_sections/isa-ins";
import IsaContact from "./_sections/isa-contact";
import IsaCode from "./_sections/isa-code";

export default function IsaInstructionsPage() {
  return (
    <section className="bg-gradient-to-tl to-slate-900 from-gbci-primary -mb-16 px-page-xl">
      <IsaIntro></IsaIntro>
      <IsaIns></IsaIns>
      {/* <IsaContact></IsaContact> */}
      {/* <IsaCode></IsaCode> */}
    </section>
  );
}
